<template>
  <div v-if="api_data.Farmer && api_data.Farmer[file_input_name]"
       style="margin-bottom: 10px; overflow: auto;"
  >
    <div style="margin-bottom: 10px;"
         v-if="operation_mode == 'write'" class="row">
      <div class="col-md-12">
        <div class="card card-custom">
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">{{ $t(head_title) || 'N/A' }}
                <br>
                {{ file_input_name }}
              </h3>
            </div>
            <div class="card-toolbar">
              <div class="float-left">
                <div class="radio-inline">
                  <div v-for="(default_question_options_each, index) in default_question_options"
                       :key="index">
                    <label class="radio radio-lg">
                      <input type="radio"
                             v-bind:value="default_question_options_each.value"
                             v-bind:name="file_input_name +  'question' + index"
                             v-model="api_data.Farmer[file_input_name].question"
                      >
                      {{ ' ' + $t(default_question_options_each.label) + ' ' }}
                      <span></span>
                    </label>
                  </div>
                  <label class="radio radio-lg">
                    <input type="radio"
                           :value="''"
                           :name="file_input_name +  'question_nothing'"
                           v-model="api_data.Farmer[file_input_name].question">
                    {{ $t('Reset') }}
                    <span></span>
                  </label>
                </div>
              </div>
              <div class="btn-group" role="group" aria-label="">
                <div
                    v-if="default_autocomplete_list.length"
                    v-on:click="setDefaultFromAutocomplete()"
                    class="btn btn-info"
                ><i class="flaticon-multimedia-4"></i>
                </div>
                <div
                    v-if="api_data.Farmer[file_input_name].extra_data.length"
                    v-on:click="resetExtraData()"
                    class="btn btn-danger"
                ><i class="flaticon2-refresh-1"></i>
                </div>
                <div v-on:click="dataTakenAdd()"
                     class="btn btn-primary"
                ><i class="flaticon2-add"></i>
                </div>
              </div>
            </div>
          </div>
          <div v-if="api_data.Farmer[file_input_name].extra_data.length">
            <div v-for="(data_in_json_each, index) in api_data.Farmer[file_input_name].extra_data"
                 :key="index"
                 class="card-body">
              <div class="row">
                <div class="col-md-11">
                  <div class="row">
                    <div :class="default_form_fields_class || 'col-md-6'"
                         v-for="(form_fields_each,indexInner) in form_fields"
                         :key="indexInner"
                    >
                      <div v-if="form_fields_each.type == 'textarea'">
                        <label>{{ $t(form_fields_each.label) }}</label>
                        <textarea class="form-control form-control-solid"
                                  :placeholder="form_fields_each.label"
                                  v-model="data_in_json_each[form_fields_each.name]"
                        ></textarea>
                      </div>
                      <div v-if="form_fields_each.type != 'textarea'">
                        <label>{{ $t(form_fields_each.label) }}</label>
                        <input class="form-control form-control-solid"
                               v-model="data_in_json_each[form_fields_each.name]"
                               :placeholder="form_fields_each.label"
                               :list="file_input_name +  'datalist' + form_fields_each.name"
                        >
                        <datalist open="open"
                                  :id="file_input_name +  'datalist' + form_fields_each.name">
                          <option
                              v-for="(default_autocomplete_list_each,indexInnerList) in default_autocomplete_list"
                              :key="indexInnerList"
                          >
                            {{ default_autocomplete_list_each }}
                          </option>
                        </datalist>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="form-group">
                    <label>{{ $t('Action') }}</label>
                    <div v-on:click="dataTakenDelete(index)"
                         class="form-control btn btn-danger"
                    >
                      <i class="flaticon2-delete"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="operation_mode == 'read'">
      <show-question-with-note-and-multi-input
          v-bind:head_title="head_title"
          v-bind:file_input_name="file_input_name"
          v-bind:default_autocomplete_list="default_autocomplete_list"
          v-bind:default_question_options="default_question_options"
          v-bind:api_data="api_data"
          v-bind:form_fields="form_fields"
      ></show-question-with-note-and-multi-input>
    </div>
  </div>
</template>
<script>
import showQuestionWithNoteAndMultiInput from "./showQuestionWithNoteAndMultiInput";

export default {
  name: 'question-with-note-and-multi-input',
  component: [
    showQuestionWithNoteAndMultiInput
  ],
  props: {
    head_title: String,
    file_input_name: {
      type: String,
      default: function () {
        return ''
      },
    },
    api_data: {
      type: Object,
      default: function () {
        return {}
      },
    },
    form_fields: {
      type: Object,
      default: function () {
        return {
          'title': {
            'name': 'title',
            'label': 'Particular',
          },
          'note': {
            'name': 'note',
            'type': 'textarea',
            'label': 'Note',
          }
        }
      }
    },
    operation_mode: {
      type: String,
      default: function () {
        return 'write'
      }
    },
    default_form_fields_class: {
      type: String,
      default: function () {
        return 'col-md-6'
      }
    },
    default_autocomplete_list: {
      type: Array,
      default: function () {
        return []
      }
    },
    default_question_options: {
      type: Array,
      default: function () {
        return [
          {
            'label': 'Yes',
            'value': 'yes',
          },
          {
            'label': 'No',
            'value': 'no',
          },
        ]
      }
    },
  },
  methods: {
    dataTakenDelete(index) {
      this.$props.api_data.Farmer[this.file_input_name].extra_data.splice(index, 1);
    },
    dataTakenAdd(option = null) {
      if (!option) {
        option = {
          title: '',
          note: '',
        };
      }
      this.$props.api_data.Farmer[this.file_input_name].extra_data = this.$props.api_data.Farmer[this.file_input_name].extra_data || [];
      this.$props.api_data.Farmer[this.file_input_name].extra_data.push(option);
    },
    setDefaultFromAutocomplete() {
      var tempThis = this;
      this.$props.default_autocomplete_list.forEach(function (value, index) {
        tempThis.dataTakenAdd({
          title: value,
          note: '',
        });
      });
    },
    resetExtraData() {
      this.$props.api_data.Farmer[this.file_input_name].extra_data = [];
    },
    maintain_api_data() {
      if (this.$props.api_data != undefined
          &&
          this.$props.api_data.Farmer != undefined
      ) {
        this.$props.api_data.Farmer[this.file_input_name] = this.$props.api_data.Farmer[this.file_input_name] || {
          question: '',
          extra_data: []
        };
      }
    },
  },
  updated() {
    this.maintain_api_data();
  },
  created() {
    this.maintain_api_data();
  }
}
</script>
